/**
 * View configuration: registers a profile view for UserProfile.
 *
 * @module config/views
 */
import type { ConfigType } from '@plone/registry';

import ProfileView from '../components/Profile/ProfileView';

/** The backend portal type this view is registered for. */
export const PROFILE_TYPE = 'UserProfile';

/**
 * Register ProfileView for UserProfile type.
 *
 * @param config The Volto configuration registry.
 * @returns The same registry, for chaining.
 */
export default function install(config: ConfigType) {
  config.views.contentTypesViews[PROFILE_TYPE] = ProfileView;

  return config;
}
